import { formatSuggestionForDisplay } from '../../methods/format-suggestion'
import { responseHandlerService } from '@/plugins/responseHandlerService'

/**
 * Öneri güncelleme API yanıtını işler
 * @param {Object} response - API yanıtı
 * @returns {Object} İşlenmiş yanıt: {success, data, message}
 */
export const handleResponse = (response) => {
  // Başarılı yanıt kontrolü
  if (response && response.code === 200) {
    // Başarı bildirimi göster
    responseHandlerService.handleSuccess('Öneri başarıyla güncellendi')
    
    // Data içeren başarılı yanıt
    if (response.data) {
      return {
        success: true,
        data: formatSuggestionForDisplay(response.data),
        message: 'Öneri başarıyla güncellendi'
      }
    } 
    // Data içermeyen başarılı yanıt
    else {
      return {
        success: true,
        data: null,
        message: response.message || 'Öneri başarıyla güncellendi'
      }
    }
  }
  
  // Hata durumu
  const errorMessage = response?.message || 'Bir hata oluştu'
  responseHandlerService.handleError(null, errorMessage)
  
  return {
    success: false,
    data: null,
    message: errorMessage
  }
}